/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * MiitelAuthApi - axios parameter creator
 * @export
 */
export const MiitelAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Miitel連携解除API
         * @summary Miitel連携解除API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMiitelAuth: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/miitel_auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MiitelAuthApi - functional programming interface
 * @export
 */
export const MiitelAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MiitelAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Miitel連携解除API
         * @summary Miitel連携解除API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMiitelAuth(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMiitelAuth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MiitelAuthApi - factory interface
 * @export
 */
export const MiitelAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MiitelAuthApiFp(configuration)
    return {
        /**
         * Miitel連携解除API
         * @summary Miitel連携解除API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMiitelAuth(options?: any): AxiosPromise<boolean> {
            return localVarFp.deleteMiitelAuth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MiitelAuthApi - interface
 * @export
 * @interface MiitelAuthApi
 */
export interface MiitelAuthApiInterface {
    /**
     * Miitel連携解除API
     * @summary Miitel連携解除API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiitelAuthApiInterface
     */
    deleteMiitelAuth(options?: AxiosRequestConfig): AxiosPromise<boolean>;

}

/**
 * MiitelAuthApi - object-oriented interface
 * @export
 * @class MiitelAuthApi
 * @extends {BaseAPI}
 */
export class MiitelAuthApi extends BaseAPI implements MiitelAuthApiInterface {
    /**
     * Miitel連携解除API
     * @summary Miitel連携解除API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiitelAuthApi
     */
    public deleteMiitelAuth(options?: AxiosRequestConfig) {
        return MiitelAuthApiFp(this.configuration).deleteMiitelAuth(options).then((request) => request(this.axios, this.basePath));
    }
}
